export default "__VITE_ASSET__8229efa1__"